import { Injectable } from '@angular/core';

/**
 * Lo que hay que tirar cuando cambia quién está sentado delante.
 *
 * Las cachés de los servicios `providedIn: 'root'` viven lo que vive la
 * aplicación, y cerrar sesión **no recarga la página** —`logout()` solo navega a
 * `/login`—, así que sobrevivían al cambio de cuenta: la cuenta B entraba y veía
 * el `candidateMe$` de la A, con sus URLs firmadas de documentos dentro, o los
 * permisos de quien acababa de salir.
 *
 * Cada servicio con caché se registra a sí mismo y `AuthService.clearSession()`
 * los vacía todos de una. Se hace así, y no con una lista escrita en
 * `AuthService`, porque esa lista se queda desactualizada el día que alguien
 * añade la séptima caché — y el fallo que provoca no se ve en ninguna pantalla,
 * solo aparece cuando dos personas comparten un navegador.
 *
 * Un servicio que nunca se ha inyectado no está registrado, y tampoco tiene nada
 * que vaciar: Angular no lo ha construido.
 */
@Injectable({ providedIn: 'root' })
export class SessionCacheRegistry {
	private readonly clears = new Set<() => void>();

	/** Llamar desde el constructor del servicio que cachea. */
	register(clear: () => void): void {
		this.clears.add(clear);
	}

	/** Vacía todas las cachés registradas. Nunca lanza: cerrar sesión no puede fallar. */
	clearAll(): void {
		for (const clear of this.clears) {
			try {
				clear();
			} catch {
				// Una caché que no sabe vaciarse no puede impedir el cierre de sesión
				// de las demás, que es exactamente lo que hay que garantizar aquí.
			}
		}
	}
}
